import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import {useAttendeeVariables} from 'Event'
import TextContent from 'lib/ui/form/HTMLEditor/HTMLContent'
import QuestionIcon from 'Event/Sponsors/QuestionIcon'
import {Sponsor} from 'Event/Sponsors'
import {useCardsTemplate} from 'Event/template/Cards'

type BodyProps = {
  sponsor: Sponsor
  toggleForm: () => void
  id: string
}

export default function Body(props: BodyProps) {
  const {sponsor, id} = props
  const v = useAttendeeVariables()
  const {sponsors, textColor} = useCardsTemplate()
  const nameColor = sponsors.nameColor ?? textColor

  return (
    <Box>
      <SponsorHeader>
        <StyledTypography variant="h5" $textColor={nameColor}>
          {v(sponsor.name)}
        </StyledTypography>
        <StyledQuestionIcon
          sponsor={sponsor}
          onClick={props.toggleForm}
          id={id}
        />
      </SponsorHeader>
      <StyledTextContent>{v(sponsor.description)}</StyledTextContent>
    </Box>
  )
}

const Box = styled.div`
  width: 100%;
`

const StyledTypography = styled(Typography)<{$textColor: string}>`
  color: ${(props) => props.$textColor};
`

const StyledQuestionIcon = styled(QuestionIcon)`
  margin-right: 10px;
`
const SponsorHeader = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledTextContent = styled(TextContent)`
  display: none;

  @media (min-width: ${(props) => props.theme.breakpoints.sm}) {
    display: initial;
  }
`
